import { api, getStoreId } from "./api";

export const createOrder = async ({
	clientId,
	phone_number,
	country_code,
	first_name,
	last_name,
	receiver_name,
	receiver_phone,
	receiver_country_code,
	addressId,
	pickup_on_store,
	street,
	street_number,
	complement,
	reference_point,
	neighborhood,
	city,
	state,
	postal_code,
	country,
	description,
	additional_information,
	delivery_date,
	payment_method,
	payment_received,
	products_value,
	discount,
	delivery_fee,
	total,
	status,
	has_card,
	created_by,
	online_order,
	store_front_order,
	online_code,
	products,
	is_delivery,
	card_from,
	card_to,
	card_message,
	store_id: receivedStoreId,
	store_slug,
	order_email,
	coupon_code,
	coupon_id
}: any) => {
	// Usar store_id recebido (do storefront) ou obter do admin logado
	const store_id = receivedStoreId || getStoreId();
	console.log('country_code service', country_code)	
	const response = await api.post("/order", {
		store_id,  // Adicionar store_id automaticamente
		store_slug,  // Slug da loja extraído da URL (fallback se store_id for null)
		clientId,
		first_name,
		last_name,
		phone_number,
		country_code,
		receiver_name,
		receiver_phone,
		receiver_country_code,
		addressId,
		pickup_on_store,
		street,
		street_number,
		complement,
		reference_point,
		neighborhood,
		city,
		state,
		postal_code,
		country,
		description,
		additional_information,
		delivery_date,
		products_value,
		discount,
		delivery_fee,
		total,
		payment_method,
		payment_received,
		status,
		has_card,
		created_by,
		online_order,
		store_front_order,
		online_code,
		products,
		is_delivery,
		card_from,
		card_to,
		card_message,
		order_email,
		coupon_code,
		coupon_id
	});

	return response;
};

export const createOrderByAi = async (data: any) => {
	const store_id = getStoreId();
	const response = await api.post("/order/ai", { ...data, store_id });

	return response;
}

export const getCompletedOrder = async (id: string) => {
	const response = api.get(`/order/completedOrder/${id}`);

	return response;
}

export const getOrderIdByShortCode = async (code: string) => {
	const response = api.get(`/order/short/${code}`);

	return response;
}


export const getOrderById = async(id: string) => {
	const response = await api.get(`/order/detail/${id}`);

	return response;
};

export const getOnGoingOrders = async () => {
	const response = await api.get("/order/ongoing");

	return response;
};

export const getPanelOrders = async () => {
	const response = await api.get("/order/panel");

	return response;
};

export interface IOrderSearchFilters {
	query?: string;
	clientName?: string;
	orderCode?: string;
	phoneNumber?: string;
	productName?: string;
}

export const getAllOrders = async (page: number, pageSize: number, filters?: IOrderSearchFilters, startDate?: string | null, endDate?: string | null) => {
	const params = new URLSearchParams({
		page: String(page),
		pageSize: String(pageSize)
	});

	if (filters?.query) params.set('query', filters.query);
	if (filters?.clientName) params.set('clientName', filters.clientName);
	if (filters?.orderCode) params.set('orderCode', filters.orderCode);
	if (filters?.phoneNumber) params.set('phoneNumber', filters.phoneNumber);
	if (filters?.productName) params.set('productName', filters.productName);
	if (startDate) params.set('startDate', startDate);
	if (endDate) params.set('endDate', endDate);

	const response = await api.get(`/order/all?${params.toString()}`);

	return response;
}

export const getWaitingOrders = async () => {
	const response = await api.get("/order/waitingForClient");

	return response;
}

export const updateStatus = async({
	id,
	status
}: any) => {
	const response = await api.patch(`/order/${id}`, {
		id,
		status
	});

	return response;
};

export const updateOrder = async(order: any) => {
	const response = await api.put(`/order/${order.id}`, {
		order
	});

	return response;
};

export const updateOrderPaymentStatus = async(id: string, payment_received: boolean) => {
	const response = await api.patch(`/order/${id}/payment`, {
		payment_received
	});

	return response.data;
};

export const markOrderAsPrinted = async(id: string) => {
	const response = await api.patch(`/order/${id}/printed`);

	return response.data;
};

export const confirmDeliveryPayment = async(orderId: string) => {
	const response = await api.patch(`/orderDelivery/${orderId}/confirm-payment`);

	return response.data;
};

export const finishOnlineOrder = async(order: any) => {
	const response = await api.put(`/order/finish/${order.id}`, {
		order,
	});

	return response;
};

export const deleteOrder = async(id: string) => {
	const response = await api.delete(`/order/${id}`);

	return response;
};

export const getOrderStatus = async(orderId: string) => {
	const response = await api.get(`/order/status/${orderId}`);
	return response.data;
};
